module.exports = __webpack_public_path__ + "img/pic-fw.3a232f49.png";